import { useQuery } from '@tanstack/react-query';
import request from '@/services/api';

export const usePartnerList = (params?: any) => {
  return useQuery({
    queryKey: ['partner-list', params],
    queryFn: async () => {
      const res = await request.get('/partner', { params });
      return res.data;
    }
  });
};
